import { Component, Input, ContentChild, Output, AfterViewInit, EventEmitter, OnDestroy, ChangeDetectionStrategy, ChangeDetectorRef, ViewChild, NgZone, Renderer2 } from '@angular/core';

import { AnimationEvent } from '../animations/animations.interface';

import { BoxContentDirective, BoxFooterDirective, BoxHeaderDirective, BoxToolsDirective } from './box.directive';
export class BoxComponent implements AfterViewInit, OnDestroy {
public isCollaping: boolean;
public remove = false;
public removed: boolean;
private toggleButtonListener: Function;
private removeButtonListener: Function;
public boxColor = 'default';
public buttonsStyleClass = 'btn btn-box-tool';
public contentStyleClass = 'box-content-wrapper';
public contentColor: string;
public footer: string;
public footerColor: string;
public footerStyleClass = 'box-footer';
public header: string;
public headerBorder = true;
public headerColor: string;
public headerStyleClass = 'box-header';
public isCollapsable = true;
public isCollapsed = false;
public isLoading: boolean;
public isRemovable = true;
public isSolid = false;
public loadingColor: string;
public loadingStyleClass = 'fa fa-refresh fa-spin';
public styleClass = 'box';
public onCollapseDone = new EventEmitter();
public onCollapseStart = new EventEmitter();
public boxHeaderDirective: BoxHeaderDirective;
public boxFooterDirective: BoxFooterDirective;
public boxContentDirective: BoxContentDirective;
public boxToolsDirective: BoxToolsDirective;
private toggleButtonElement;
private removeButtonElement;
/**
 * \@method constructor
 * @param {?} changeDetectorRef
 * @param {?} ngZone
 * @param {?} renderer2
 */
constructor(
private changeDetectorRef: ChangeDetectorRef,
private ngZone: NgZone,
private renderer2: Renderer2
  ) {}
/**
 * \@method ngAfterViewInit
 * @return {?}
 */
ngAfterViewInit() {
    this.ngZone.runOutsideAngular(() => {
      if(this.toggleButtonElement) {
        this.toggleButtonListener = this.renderer2.listen(this.toggleButtonElement.nativeElement, 'click', (event: Event) => {
          this.isCollapsed = !this.isCollapsed;
          this.changeDetectorRef.detectChanges();
        });
      }
      if(this.removeButtonElement) {
        this.removeButtonListener = this.renderer2.listen(this.removeButtonElement.nativeElement, 'click', (event: Event) => {
          this.remove = true;
          this.changeDetectorRef.detectChanges();
        });
      }
    });
  }
/**
 * \@method ngOnDestroy
 * @return {?}
 */
ngOnDestroy() {
    if(this.toggleButtonListener) {
      this.toggleButtonListener();
    }
    if(this.removeButtonListener) {
      this.removeButtonListener();
    }
  }
/**
 * [removedDone description]
 * \@method removedDone
 * @param {?} event
 * @return {?}
 */
public removedDone(event): void {
    if(event.toState === '1') {
      this.removed = true;
    }
  }
/**
 * [collapseStart description]
 * \@method collapseStart
 * @param {?} event
 * @return {?}
 */
public collapseStart(event: AnimationEvent): void {
    if(event.fromState !== 'void') {
      this.isCollaping = true;
      this.onCollapseStart.emit(event);
    }
  }
/**
 * [collapseDone description]
 * \@method collapseDone
 * @param {?} event
 * @return {?}
 */
public collapseDone(event: AnimationEvent): void {
    if(event.fromState !== 'void') {
      this.isCollaping = false;
      this.onCollapseDone.emit(event);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mk-box',
  template: `
    <div *ngIf="!removed" [mkColor]="boxColor" mkColorProperty="border-color" mkColorPrefix="box" [ngClass]="styleClass" [class.collapsed-box]="isCollapsed && !isCollaping" [class.box-solid]="isSolid">
      <div *ngIf="header || boxHeaderDirective" [ngClass]="headerStyleClass" [mkColor]="boxColor" [mkColorCondition]="isSolid" mkColorProperty="background-color" [class.with-border]="headerBorder">
        <h3 class="box-title" [mkFontColor]="headerColor">
          {{header}}
          <ng-content select="mk-box-header"></ng-content>
        </h3>
        <div class="box-tools pull-right">
          <ng-content select="mk-box-tools"></ng-content>
          <button *ngIf="isCollapsable" type="button" [ngClass]="buttonsStyleClass" #toggleButtonElement>
            <i class="fa" [ngClass]="{'fa-plus': isCollapsed, 'fa-minus': !isCollapsed}"></i>
          </button>
          <button *ngIf="isRemovable" type="button" [ngClass]="buttonsStyleClass" #removeButtonElement>
            <i class="fa fa-times"></i>
          </button>
        </div>
      </div>
      <div [ngClass]="contentStyleClass" [mkFontColor]="contentColor" [collapseAnimation]="isCollapsed" (collapseAnimation.start)="collapseStart($event)" (collapseAnimation.done)="collapseDone($event)">
        <div class="box-body">
          <ng-container *ngIf="boxHeaderDirective || boxContentDirective || boxFooterDirective || BoxToolsDirective else noDirective">
            <ng-content select="mk-box-content"></ng-content>
          </ng-container>
          <ng-template #noDirective>
            <ng-content></ng-content>
          </ng-template>
        </div>
        <div *ngIf="footer || boxFooterDirective" [ngClass]="footerSyleClass" [mkFontColor]="footerColor">
          {{footer}}
          <ng-content select="mk-box-footer"></ng-content>
        </div>
      </div>
      <div *ngIf="isLoading" class="overlay">
        <i [ngClass]="loadingStyleClass" [mkFontColor]="loadingColor"></i>
      </div>
    </div>
  `,
  styles: [`
    .box.collapsed-box .box-body,
    .box.collapsed-box .box-footer {
      display: inherit;
    }

    .box-solid {
      border: 1px solid;
    }

    .box-body {
      background-color: #fff;
    }

    .box.box-solid.bg-color > .box-header {
      color: #fff;
    }
  `],
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ChangeDetectorRef, },
{type: NgZone, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'boxColor': [{ type: Input },],
'buttonsStyleClass': [{ type: Input },],
'contentStyleClass': [{ type: Input },],
'contentColor': [{ type: Input },],
'footer': [{ type: Input },],
'footerColor': [{ type: Input },],
'footerStyleClass': [{ type: Input },],
'header': [{ type: Input },],
'headerBorder': [{ type: Input },],
'headerColor': [{ type: Input },],
'headerStyleClass': [{ type: Input },],
'isCollapsable': [{ type: Input },],
'isCollapsed': [{ type: Input },],
'isLoading': [{ type: Input },],
'isRemovable': [{ type: Input },],
'isSolid': [{ type: Input },],
'loadingColor': [{ type: Input },],
'loadingStyleClass': [{ type: Input },],
'styleClass': [{ type: Input },],
'onCollapseDone': [{ type: Output },],
'onCollapseStart': [{ type: Output },],
'boxHeaderDirective': [{ type: ContentChild, args: [BoxHeaderDirective, ] },],
'boxFooterDirective': [{ type: ContentChild, args: [BoxFooterDirective, ] },],
'boxContentDirective': [{ type: ContentChild, args: [BoxContentDirective, ] },],
'boxToolsDirective': [{ type: ContentChild, args: [BoxToolsDirective, ] },],
'toggleButtonElement': [{ type: ViewChild, args: ['toggleButtonElement', ] },],
'removeButtonElement': [{ type: ViewChild, args: ['removeButtonElement', ] },],
};
}

function BoxComponent_tsickle_Closure_declarations() {
/** @type {?} */
BoxComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
BoxComponent.ctorParameters;
/** @type {?} */
BoxComponent.propDecorators;
/** @type {?} */
BoxComponent.prototype.isCollaping;
/** @type {?} */
BoxComponent.prototype.remove;
/** @type {?} */
BoxComponent.prototype.removed;
/** @type {?} */
BoxComponent.prototype.toggleButtonListener;
/** @type {?} */
BoxComponent.prototype.removeButtonListener;
/** @type {?} */
BoxComponent.prototype.boxColor;
/** @type {?} */
BoxComponent.prototype.buttonsStyleClass;
/** @type {?} */
BoxComponent.prototype.contentStyleClass;
/** @type {?} */
BoxComponent.prototype.contentColor;
/** @type {?} */
BoxComponent.prototype.footer;
/** @type {?} */
BoxComponent.prototype.footerColor;
/** @type {?} */
BoxComponent.prototype.footerStyleClass;
/** @type {?} */
BoxComponent.prototype.header;
/** @type {?} */
BoxComponent.prototype.headerBorder;
/** @type {?} */
BoxComponent.prototype.headerColor;
/** @type {?} */
BoxComponent.prototype.headerStyleClass;
/** @type {?} */
BoxComponent.prototype.isCollapsable;
/** @type {?} */
BoxComponent.prototype.isCollapsed;
/** @type {?} */
BoxComponent.prototype.isLoading;
/** @type {?} */
BoxComponent.prototype.isRemovable;
/** @type {?} */
BoxComponent.prototype.isSolid;
/** @type {?} */
BoxComponent.prototype.loadingColor;
/** @type {?} */
BoxComponent.prototype.loadingStyleClass;
/** @type {?} */
BoxComponent.prototype.styleClass;
/** @type {?} */
BoxComponent.prototype.onCollapseDone;
/** @type {?} */
BoxComponent.prototype.onCollapseStart;
/** @type {?} */
BoxComponent.prototype.boxHeaderDirective;
/** @type {?} */
BoxComponent.prototype.boxFooterDirective;
/** @type {?} */
BoxComponent.prototype.boxContentDirective;
/** @type {?} */
BoxComponent.prototype.boxToolsDirective;
/** @type {?} */
BoxComponent.prototype.toggleButtonElement;
/** @type {?} */
BoxComponent.prototype.removeButtonElement;
/** @type {?} */
BoxComponent.prototype.changeDetectorRef;
/** @type {?} */
BoxComponent.prototype.ngZone;
/** @type {?} */
BoxComponent.prototype.renderer2;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
